@if (progressSignal(); as progress) {
  <div class="flex items-center justify-between p-3 bg-gray-800 rounded-lg border border-gray-700/50 transition-all duration-300 ease-in-out hover:bg-gray-700/50 w-full">
    <!-- Status Icon -->
    <div class="flex items-center gap-3 flex-1 min-w-0">
      @switch (progress.status) {
        @case ('COMPLETED') {
          <div class="w-8 h-8 flex items-center justify-center rounded-full bg-green-500/20 flex-shrink-0">
            <nrc-icon name="multi-check" class="w-4 h-4 text-green-500" />
          </div>
        }
        @case ('FAILED') {
          <div class="w-8 h-8 flex items-center justify-center rounded-full bg-red-500/20 flex-shrink-0">
            <nrc-icon name="info-outline" class="w-4 h-4 text-red-500" />
          </div>
        }
        @default {
          <div class="w-8 h-8 flex items-center justify-center rounded-full bg-blue-500/20 flex-shrink-0">
            <nrc-loading-spinner class="w-full h-full" color="active" />
          </div>
        }
      }

      <!-- File Information -->
      <div class="flex-1 min-w-0">
        <div class="text-sm font-medium text-gray-200 truncate">
          {{ filename() }}
        </div>
        <div class="text-xs text-gray-400 truncate">
          @switch (progress.status) {
            @case ('COMPLETED') {
              Completed processing {{ filename() }}
            }
            @case ('FAILED') {
              Failed to process {{ filename() }}
            }
            @default {
              Processing {{ filename() }}
            }
          }
        </div>
      </div>
    </div>

    <!-- Status Badge -->
    <div class="flex items-center flex-shrink-0 ml-2">
      @switch (progress.status) {
        @case ('COMPLETED') {
          <span class="px-2 py-1 text-xs font-medium rounded-full text-nowrap text-green-500 bg-green-500/10">
            Completed
          </span>
        }
        @case ('FAILED') {
          <span class="px-2 py-1 text-xs font-medium rounded-full text-nowrap text-red-500 bg-red-500/10">
            Failed
          </span>
        }
        @default {
          <span class="px-2 py-1 text-xs font-medium rounded-full text-nowrap text-blue-500 bg-blue-500/10">
            Processing
          </span>
        }
      }
    </div>
  </div>
}
